import SplitItemRow, { SplitItemView } from '@/features/openTabs/components/SplitItemRow'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { ScrollView, View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface SplitColumnProps {
    title?: string
    items: SplitItemView[]
    direction: 'forward' | 'back'
    disabled?: boolean
    scrollable?: boolean
    onMove: (itemId: string) => void
}

const SplitColumn: FC<SplitColumnProps> = ({
    title,
    items,
    direction,
    disabled,
    scrollable = true,
    onMove,
}) => {
    const { styles } = useStyles(stylesheet)
    const rows = items.map((item) => (
        <SplitItemRow
            key={item.id}
            item={item}
            direction={direction}
            disabled={disabled}
            onMove={() => onMove(item.id)}
        />
    ))

    return (
        <View
            style={[
                styles.container,
                scrollable ? styles.scrollableContainer : styles.staticContainer,
            ]}
        >
            {title && <Typography.Heading variant="h5">{title}</Typography.Heading>}
            {scrollable ? (
                <ScrollView
                    style={styles.scroll}
                    contentContainerStyle={styles.content}
                    showsVerticalScrollIndicator={false}
                >
                    {rows}
                </ScrollView>
            ) : (
                <View style={styles.content}>{rows}</View>
            )}
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        width: '100%',
        gap: 8,
        paddingHorizontal: 16,
    },
    scrollableContainer: {
        flex: 1,
        minHeight: 0,
    },
    scroll: {
        flex: 1,
    },
    staticContainer: {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 'auto',
    },
    content: {
        gap: 8,
        paddingBottom: 16,
    },
})

export default SplitColumn
